import { render } from "./homeComponents.vue?vue&type=template&id=c630e9d4"
import script from "./homeComponents.vue?vue&type=script&lang=js"
export * from "./homeComponents.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__